export default __webpack_public_path__ + "static/media/leaderboard-game-img.bc435649.png";